/**
 * Libyan dinar.
 */
export var LYD = {
  code: 'LYD',
  base: 10,
  exponent: 3
};